import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { HeaderManager } from 'inside-out/managers/headerManager';
import { FullWidthCTA } from 'inside-out/components/shared/fullWidthCTA';
import { format } from 'inside-out/managers/dateManager';

import {
	thumbnailStyle,
	innerWrapperStyle,
	titleStyle,
	bodyStyle,
	categoryTitleStyle,
	dateStyle,
	ctaStyle,
} from 'inside-out/page-styles/news-and-events/detail';

import { detailSideBarLayout, contentSection, grey } from 'inside-out/global-styles';

// Gatsby requires a specific export format on Templates.
export default class NewsDetail extends React.PureComponent {
	static propTypes = {
		data: PropTypes.shape({
			news: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							id: PropTypes.string.isRequired,
							title: PropTypes.string.isRequired,
							body: PropTypes.string.isRequired,
							date: PropTypes.string.isRequired,
							fields: PropTypes.shape({
								thumbnail_image: PropTypes.shape({
									childImageSharp: PropTypes.shape({
										resize: PropTypes.shape({
											src: PropTypes.string.isRequired,
										}).isRequired,
									}).isRequired,
								}).isRequired,
							}),
							attachments: PropTypes.arrayOf(
								PropTypes.shape({
									file: PropTypes.string,
									link_text: PropTypes.string,
									url: PropTypes.string,
									vimeo_url: PropTypes.string,
								})
							),
						}).isRequired,
					})
				).isRequired,
			}).isRequired,
		}).isRequired,
	};

	componentDidMount = () => {
		HeaderManager.headerProperties = {};
	};

	convertVimeoURL = vimeo_url => {
		var replacement = '//player.vimeo.com/video/$1';
		return vimeo_url.replace(/(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g, replacement);
	};

	render() {
		const { node } = this.props.data.news.edges[0];

		return (
			<section>
				<Helmet title={ node.title }>
					<meta name="description" content={ node.extract }/>
			    <meta property="og:type" content="article"/>
			    <meta property="og:title" content={ node.title }/>
			    <meta property="og:description" content={ node.extract }/>
			    { node.fields && node.fields.thumbnail_image && node.fields.thumbnail_image.childImageSharp.resize.src && (
				    <meta property="og:image" content={ 'https://insideoutinstitute.org.au' + node.fields.thumbnail_image.childImageSharp.resize.src }/>
		    	) }
				</Helmet>

				<div className={innerWrapperStyle}>
					<div className={detailSideBarLayout.wrapper}>
						<div className={detailSideBarLayout.leftSide}>
							<div className={contentSection('#fff')}>
								{node.fields && (
									<div className={thumbnailStyle}>
										<img src={node.fields.thumbnail_image.childImageSharp.resize.src} />
									</div>
								)}
								<p className={categoryTitleStyle(grey)}>{node.type}</p>
								<h1 className={titleStyle}>{node.title}</h1>
								<p className={dateStyle}>{format(node.date)}</p>
								<div className={bodyStyle} dangerouslySetInnerHTML={{ __html: node.body }} />
								<div className={ctaStyle}>
									{ node.attachments && node.attachments.map((attachment, index) => {
										const href = attachment.file || attachment.url;

										if (attachment.vimeo_url) {
											return (
												<iframe
													key={ index }
													src={ this.convertVimeoURL(attachment.vimeo_url) }
													width="100%"
													height="360"
													frameBorder="0"
													webkitallowfullscreen="true"
													mozallowfullscreen="true"
													allowFullScreen="true"
												/>
											);
										} else if (href) {
											return (
												<FullWidthCTA key={ index } link={{ href }}>
													{ attachment.link_text || 'View press release' }
												</FullWidthCTA>
											);
										}
									}) }
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export const query = graphql`
	query NewsDetailPageQuery($id: String) {
		news: allNewsJson(filter: { id: { eq: $id } }) {
			edges {
				node {
					id
					title
					extract
					type
					date
					body
					attachments {
						file
						url
						link_text
						vimeo_url
					}
				  fields {
					 	thumbnail_image {
					 		childImageSharp {
					 			resize(width: 552, height: 400) {
					 				src
					 			}
					 		}
					 	}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/news-and-events/news-detail/index.js